export default "__VITE_ASSET__9ff331e8__"